(function () {
  'use strict';

  var CLE = 'cm-globo-produits-v2';

  var DUREE = 7 * 24 * 60 * 60 * 1000;
  var PLAFOND = 2;

  var regles = null;
  var position = '';
  var produits = null;
  var enCours = false;

  function lireRegles() {
    var n = document.getElementById('cm-globo-pastilles');
    if (!n) return null;
    position = n.getAttribute('data-position') || '';
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }

  function conteneur(media) {
    var c = media.querySelector('.product-label-container');
    if (c) return c;
    c = document.createElement('div');
    c.className = 'product-label-container cm-globo-pose' + (position ? ' absolute ' + position : '');
    media.appendChild(c);
    return c;
  }

  function lireCache() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) return null;
      var o = JSON.parse(brut);
      if (!o || !o.t || (Date.now() - o.t) > DUREE) return null;
      return o.m || null;
    } catch (e) { return null; }
  }

  function ecrireCache(m) {
    try { window.localStorage.setItem(CLE, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
  }

  function rafraichir() {
    return fetch('/products.json?limit=250', { credentials: 'same-origin', cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) return null;
        var m = {};
        d.products.forEach(function (p) {
          var v = (p.variants && p.variants[0]) ? p.variants[0].id : '';
          m[p.handle] = {

            i: p.id,
            t: (p.tags || []).map(function (x) { return String(x).toLowerCase(); }),
            n: String(p.title || '').toLowerCase(),
            v: v,

            p: (p.variants && p.variants.length)
              ? Math.min.apply(null, p.variants.map(function (x) { return parseFloat(x.price); }))
              : null
          };
        });
        ecrireCache(m);
        return m;
      })
      .catch(function () { return null; });
  }

  function correspond(regle, handle, prod) {
    var i;
    for (i = 0; i < regle.e.length; i++) {
      if (prod.t.indexOf(regle.e[i]) !== -1) return true;
    }
    if (regle.m && regle.m.length) {
      var botte = handle.toLowerCase() + ' ' + prod.n;
      for (i = 0; i < regle.m.length; i++) {
        if (regle.m[i] && botte.indexOf(regle.m[i]) !== -1) return true;
      }
    }
    return false;
  }

  function cle(t) {
    return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function pastille(regle) {
    var d = document.createElement('div');
    d.className = 'product-label-wrapper flex cm-globo-pose';
    var s = document.createElement('span');
    s.className = 'product-label product-label--custom product-label--cm' + (regle.g ? ' product-label--cm-degrade' : '');
    s.setAttribute('style', regle.s);
    s.textContent = regle.l;
    d.appendChild(s);
    return d;
  }

  function coeur(handle, prod) {
    var d = document.createElement('div');
    d.className = 'cm-wishlist-bouton cm-wishlist-bouton--flottant cm-globo-pose';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wk-button';
    b.setAttribute('data-product-handle', handle);
    if (prod.v) b.setAttribute('data-variant-id', String(prod.v));
    b.setAttribute('data-texte-ajouter', 'Ajouter aux favoris');
    b.setAttribute('data-texte-dedans', 'Retirer des favoris');
    b.setAttribute('aria-label', 'Ajouter aux favoris');
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML =
      '<span class="wk-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 64 64" focusable="false" role="presentation">' +
      '<path d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>' +
      '</svg></span>' +
      '<span class="wk-text visually-hidden">Ajouter aux favoris</span>';
    d.appendChild(b);
    return d;
  }

  function nettoyer() {
    var grille = document.getElementById('gf-products');
    if (!grille) return;
    var poses = grille.querySelectorAll('.cm-globo-pose');
    for (var i = 0; i < poses.length; i++) poses[i].remove();
    var cartes = grille.querySelectorAll('[data-cm-globo]');
    for (var j = 0; j < cartes.length; j++) cartes[j].removeAttribute('data-cm-globo');
  }

  function peindre() {
    if (enCours || !regles || !produits) return;
    var grille = document.getElementById('gf-products');
    if (!grille) return;

    enCours = true;
    try {
      var cartes = grille.children;
      for (var i = 0; i < cartes.length; i++) {
        var li = cartes[i];
        if (li.hasAttribute('data-cm-globo')) continue;

        var lien = li.querySelector('a[href*="/products/"]');
        if (!lien) continue;

        var handle = lien.getAttribute('href').split('/products/')[1];
        if (!handle) continue;
        handle = handle.split('?')[0].split('#')[0];

        var prod = produits[handle];
        li.setAttribute('data-cm-globo', prod ? '1' : '0');
        if (!prod) continue;

        if (estCadeau(prod)) {
          li.remove();
          i--;
          continue;
        }

        var media = li.querySelector('.card__media') || li.querySelector('.media');
        if (!media) continue;

        var etiquettes = media.querySelectorAll('.product-label');
        var deja = etiquettes.length;
        var budget = PLAFOND - deja;

        var presents = {};
        for (var e = 0; e < etiquettes.length; e++) {
          presents[cle(etiquettes[e].textContent)] = 1;
        }

        var hote = null;
        for (var r = 0; r < regles.length && budget > 0; r++) {
          if (!correspond(regles[r], handle, prod)) continue;
          var k = cle(regles[r].l);
          if (presents[k]) continue;
          presents[k] = 1;
          if (!hote) hote = conteneur(media);
          hote.appendChild(pastille(regles[r]));
          budget--;
        }

        if (!media.querySelector('.cm-wishlist-bouton')) {
          media.appendChild(coeur(handle, prod));
        }
      }
    } finally {
      enCours = false;
    }
    reveler();
  }

  function reveler() {
    document.documentElement.classList.remove('cm-globo-attente');
  }

  function demarrer() {
    regles = lireRegles();
    if (!regles || !regles.length) return;
    if (!document.getElementById('gf-products') && !document.getElementById('gf-grid')) {

      reveler();
      return;
    }

    var attache = false;
    function attacher() {
      if (attache) return;
      attache = true;
      document.addEventListener('globoFilterRenderCompleted', peindre);
      var attente = null;
      var obs = new MutationObserver(function () {
        if (enCours || attente) return;
        attente = requestAnimationFrame(function () { attente = null; peindre(); });
      });
      var cible = document.getElementById('gf-grid') || document.getElementById('gf-products');
      if (cible) obs.observe(cible, { childList: true, subtree: true });
    }

    var cache = lireCache();
    if (cache) {
      produits = cache;
      peindre();
      attacher();
    }

    rafraichir().then(function (m) {
      if (!m) { reveler(); attacher(); return; }
      var change = !produits || JSON.stringify(m) !== JSON.stringify(produits);
      produits = m;
      if (change) {
        nettoyer();
        peindre();
      }
      attacher();
    });
  }

  var ZONES_SURES = '#xboost-upsell-slide-cart-root,.xboost-slide-cart-width,cart-drawer,.cart__items,.cc-main-cart,form[action*="/cart"]';

  function estCadeau(prod) {
    if (!prod) return false;
    if (prod.t.indexOf('en-vente') !== -1) return false;
    return prod.p === 0
      || prod.t.indexOf('composeur-seul') !== -1;
  }

  function poigneeDe(a) {
    var h = a.getAttribute('href') || '';
    var i = h.indexOf('/products/');
    if (i === -1) return '';
    var q = h.slice(i + 10).split('?')[0].split('#')[0].split('/')[0];
    try { q = decodeURIComponent(q); } catch (e) {  }
    return q;
  }

  var PANNEAUX = '#glFilter-search-popup,.glFilter-search-popup,.gl-filter-search-fullscreen,.gl-list__content,[class*="gl-search"],[class*="gf-search"],#gf-products,#gf-grid,predictive-search,.predictive-search';

  function idsCadeaux() {
    var s = {};
    if (!produits) return s;
    for (var h in produits) {
      if (produits[h] && produits[h].i && estCadeau(produits[h])) s[String(produits[h].i)] = 1;
    }
    return s;
  }

  function balayerCadeaux() {
    if (!produits) return;

    var ids = idsCadeaux();
    var panneaux = document.querySelectorAll(PANNEAUX);
    for (var k = 0; k < panneaux.length; k++) {
      if (panneaux[k].closest(ZONES_SURES)) continue;
      var cartes = panneaux[k].querySelectorAll('[data-product-id]');
      for (var j = 0; j < cartes.length; j++) {
        var c = cartes[j];
        if (!ids[String(c.getAttribute('data-product-id'))]) continue;
        var carte = c.closest('.gl-product-card, .gl-card, li, [class*="product-card"]') || c;
        if (carte && carte.parentNode) carte.parentNode.removeChild(carte);
      }
    }

    var liens = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      if (!estCadeau(produits[poigneeDe(a)])) continue;
      if (a.closest(ZONES_SURES)) continue;
      var item = a.closest('li, .predictive-search__item, [class*="gf-search-item"], [class*="search-item"], [class*="product-item"]') || a;
      if (item && item.parentNode) item.parentNode.removeChild(item);
    }
  }

  function demarrerCadeaux() {
    var attente = null;
    function programmer() {
      if (attente) return;
      attente = setTimeout(function () { attente = null; balayerCadeaux(); }, 120);
    }
    var cache = lireCache();
    if (cache) { produits = produits || cache; balayerCadeaux(); }
    if (document.body) {
      new MutationObserver(programmer).observe(document.body, { childList: true, subtree: true });
    }
    rafraichir().then(function (m) {
      if (m) { produits = m; balayerCadeaux(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(); demarrerCadeaux(); });
  } else {
    demarrer();
    demarrerCadeaux();
  }
})();
